import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CourseProp from '../../../academy/propTypes/courseProp';
import Anchor from '../../../../commonComponents/Anchor';
import { isEnrolledOrFree } from '../../../../services/utilityFunctions';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

const detailsLinkText = (loggedUser, course) => {
  if (isEnrolledOrFree(loggedUser, course) && course.progress === 0) {
    return 'start';
  }
  if (course.progress > 0 && course.progress < 100) {
    return 'continue';
  }
  return 'details';
};

function CourseItem({ t, course }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const image = course.imageSquare || course.image;
  const imageUrl = image ? image.thumb : '/images/no_image_upload.png';

  return (
    <div className="hard-skill-course">
      <Anchor
        itemProp="url"
        content={`/academy/${course.slug}`}
        href={`/academy/${course.slug}/play`}
        className="course-image course-play-button"
      >
        <img
          alt="course preview"
          src={imageUrl}
          itemProp="image"
          content={imageUrl}
        />
      </Anchor>
      <h5 className="course-name">{course.name}</h5>
      {course._id && (
        <h6 className="course-subtitle">
          {t('profile_hardSkills_addSkillResume')}
        </h6>
      )}
      <p className="course-description">
        {course.summary || course.description}
      </p>
      {course._id && (
        <Anchor
          href={`/academy/${course.slug}`}
          className="btn m-btn--pill btn-dynamic course-link"
        >
          {t(detailsLinkText(loggedUser, course))}
        </Anchor>
      )}
    </div>
  );
}

CourseItem.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
};

export default translate(CourseItem);
